import { Button } from "antd";
import React, { useState } from "react";
import { SendInviteModal } from "../Chat/SendInviteModal";
import {
  useHostCancelInviteWithConfirmation,
  useHostRemoveTenantWithConfirmation
} from "./hooks";
import { IMatch } from "../../interfaces/intarfaces";
import { TUserShort } from "../../interfaces/interfacesChat";
import { MatchStatusEnum } from "../../utils/constants";
import styled from "styled-components/macro";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../utils/hooks/useWindowSize";

const Root = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const StudentInviteBoxMobile: React.FC<{
  student: TUserShort;
  match: IMatch;
}> = ({ match, student }) => {
  const [showEditInvite, setShowEditInvite] = useState(false);
  const handleCancel = useHostCancelInviteWithConfirmation();
  const handleRemoveTenant = useHostRemoveTenantWithConfirmation();
  const { t } = useTranslation("chats");

  const isMobile = useIsMobile();

  if (
    ![
      MatchStatusEnum.CHATTED,
      MatchStatusEnum.INVITED,
      MatchStatusEnum.ACCEPTED,
      MatchStatusEnum.PENDING,
      MatchStatusEnum.ACTIVE,
      MatchStatusEnum.ARCHIVED
    ].includes(match.match_status!)
  ) {
    return null;
  }
  return (
    <Root>
      {[
        MatchStatusEnum.INVITED,
        MatchStatusEnum.ACCEPTED,
        MatchStatusEnum.PENDING,
        MatchStatusEnum.ACTIVE
      ].includes(match.match_status!) ? (
        <Button
          type="default"
          size="middle"
          onClick={() => {
            if (match.match_status === MatchStatusEnum.INVITED) {
              handleCancel({
                host_id: match.host_id,
                student_id: match.student_id,
                house_id: match.house_id
              });
            } else {
              handleRemoveTenant({
                host_id: match.host_id,
                student_id: match.student_id,
                house_id: match.house_id
              });
            }
          }}
        >
          {t("butCancel")}
        </Button>
      ) : null}
      {[
        MatchStatusEnum.CHATTED,
        MatchStatusEnum.INVITED,
        MatchStatusEnum.ACCEPTED,
        MatchStatusEnum.PENDING,
        MatchStatusEnum.ACTIVE
      ].includes(match.match_status!) ? (
        <Button
          type="primary"
          size="middle"
          onClick={() => {
            setShowEditInvite(true);
          }}
        >
          {match.match_status! === MatchStatusEnum.CHATTED
            ? t("modalMessages.invite")
            : isMobile ? t("modalMessages.editInviteMobile") : t("modalMessages.editInvite")}
        </Button>
      ) : null}
      {showEditInvite ? (
        <SendInviteModal
          isShow={true}
          student={student}
          hostId={match.host_id}
          houseId={match.house_id}
          onClose={() => {
            setShowEditInvite(false);
          }}
          onSent={() => {
            setShowEditInvite(false);
          }}
        />
      ) : null}
    </Root>
  );
};
